import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatExpansionModule } from '@angular/material/expansion'
import { RouterModule } from '@angular/router'
import { TranslationService } from '../../../services/translation.service'
import { Dialog } from '@angular/cdk/dialog'
import { LocationService } from '../../../services/location.service'
import { CANADIAN_PROVINCES } from '../../../constants/provinces'

@Component({
  selector: 'app-location',
  imports: [RouterModule, MatExpansionModule, FormsModule],
  templateUrl: './location.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './location.component.scss',
})
export class LocationComponent {
  translationService = inject(TranslationService)
  locationService = inject(LocationService)
  dialog = inject(Dialog)

  currentLocation = ''

  constructor() {
    const locationService = this.locationService

    const lsLocation = locationService.getLocationFromLS()

    if (!lsLocation) {
      this.currentLocation = CANADIAN_PROVINCES[0].name
    }

    if (lsLocation?.country === 'Canada') {
      this.currentLocation = lsLocation?.province ?? CANADIAN_PROVINCES[0].name
    } else {
      if (lsLocation?.country) {
        this.currentLocation = lsLocation?.country
      }
    }
  }
}
